import { analyticsEvents } from './theme/components/analytics-events.js';
import { helpers } 		from './theme/helpers.js';
import { poi } 			from './theme/components/poi.js';
import { map } 			from './theme/components/map.js';
import { sliders } 	 	from './theme/components/sliders.js';
import { woo } 		 	from './theme/components/woo.js';
import { tax } 		 	from './theme/components/tax.js';
import { search } 	 	from './theme/components/search.js';
import { profile } 	 	from './theme/components/profile.js';
import { liked } 	 	from './theme/components/liked.js';
import { filters } 	 	from './theme/components/filters.js';
import { filtering } 	from './theme/components/filtering.js';
import { universal_sorting } 	from './theme/components/universal-sorting.js';
import { header } 	 	from './theme/components/header.js';
import { event } 	 	from './theme/components/event.js';
import { cache } 	 	from './theme/components/cache.js';
import { newslettter }	from './theme/components/newslettter.js';
import { langs } 		from './theme/components/langs.js';
import { productFiltering } from './theme/components/product-filtering.js';
import { MorePostsLoader } from './theme/components/load-more-posts.js';
import { DropdownSitemap } from "./theme/components/sitemap.js";
import { orderEventsByStartDate } from "./theme/components/place.js";
import { narrative } from "./theme/components/narrative.js";
import { wcProductPriceTypeTooltip } from "./theme/components/wc-product-price-type-tooltip.js";

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	
	init: function () {
		var self = this;

		// internal
		self.dateLimited();
		self.inlineYoutube();
		self.playVideo();
		self.loadTabs();
		self.toggleaMap();
		self.sharePage();
		self.smoothSroll();
		self.wrapTables();
		self.newLines();
		self.copyURI();
		self.showFromTo();

		// external
		analyticsEvents.init();
		sliders.init();
		poi.init();
		map.init();
		woo.init();
		productFiltering.init();

		tax.init();
		search.init();
		profile.init();
		liked.init();
		filters.init();
		filtering.init();
		universal_sorting.init();
		header.init();
		langs.init();
		event.init();
		cache.init();
		newslettter.init();
		narrative.init();
		MorePostsLoader.init();
		DropdownSitemap.init();
		orderEventsByStartDate.init();
		wcProductPriceTypeTooltip.init();


		jQuery( '[href="#form-contact"]' ).on( 'click', function(){
			jQuery.fancybox.open({
				src: '#form-contact',
				type : 'inline',
				touch: false,
			});
		});
	},

	showFromTo: function() {
		if( jQuery( '[data-showfrom][data-showto]' ).length == 0 ) {
			return false;
		}

		let today = new Date();
		// Zero the time to only compare dates
		today.setHours(0, 0, 0, 0);

		// Select elements that contain both data-showfrom and data-showto
		jQuery('[data-showfrom][data-showto]').each(function() {
			let $element = jQuery(this);

			// Parse date attributes
			let showFrom = new Date($element.attr('data-showfrom'));
			let showTo   = new Date($element.attr('data-showto'));

			// Zero out time for the from/to dates as well
			showFrom.setHours(0, 0, 0, 0);
			showTo.setHours(0, 0, 0, 0);

			// Check if today's date is between or equal to showFrom and showTo
			if (today >= showFrom && today <= showTo) {
				// Remove data attributes if within the date range
				$element.removeAttr('data-showfrom').removeAttr('data-showto');
			}
		});

		setTimeout(function(){
			jQuery( 'body' ).trigger( 'showFromToDone' );
		}, 100 );
	},

	copyURI: function(){
		var buttonCopy = 'data-copytarget';

		if( ! jQuery( `[${buttonCopy}]` ) ) {
			return false;
		}

		var inputCopyTarget = jQuery( `[${buttonCopy}]` ).attr( buttonCopy );
		var currentUrl = window.location.href;
        jQuery( inputCopyTarget ).val( currentUrl );

        // Copy to clipboard when the button is clicked
        jQuery( `[${buttonCopy}]` ).on( 'click', function() {
            var targetSelector = jQuery( this ).attr( buttonCopy ); // Get the target from data attribute
            var targetElement = jQuery( targetSelector ); // Select the target element

            // Select the text field
            targetElement.select();
            // targetElement[0].setSelectionRange(0, 99999); // For mobile devices

            // Copy the text inside the text field to the clipboard
            document.execCommand("copy");
        });
	},

	wrapTables: function(){
		jQuery('.article-layout .possible-text-content > table').each(function() {
			jQuery(this).wrap('<div class="wrap-table"></div>');
		});
	},

	newLines: function(){
		const self 	= this;
		const m 	= 'main ';
		const f 	= 'footer ';
		
		const elements = document.querySelectorAll( 
			`${m}h1, ${f}h1,
			${m}h2, ${f}h2,
			${m}h3, ${f}h3,
			${m}h4, ${f}h4,
			${m}h5, ${f}h5,
			${m}h6, ${f}h6,
			${m}p, ${f}p,
			${m}li, ${f}li`
		);

		elements.forEach(el => {
			self.walkNodes(el);
		});
	},

	processTextNode: function(textNode) {
		const self  = this;
	
		let content = textNode.textContent;
		const shortWords = [
			"A", "O", "O", "U", "K", "S", "V", "Z", "Do", "Na", "Pod", "Nad", "Za", "Pro", "Bez", "Při", "Před", "Po", "Od", "Ke", "Ve", "Se",
			"a", "i", "o", "u", "k", "s", "v", "z", "do", "na", "pod", "nad", "za", "pro", "bez", "při", "před", "po", "od", "ke", "ve", "se"
		];

		shortWords.forEach(word => {
			const regex = new RegExp(`\\b${word} (?=\\S)`, "g");
			content = content.replace(regex, `${word}\u00A0`);
		});

		textNode.textContent = content;
	},

	walkNodes: function(node) {
		const self  = this;
		
		if (node.nodeType === Node.TEXT_NODE) {
			self.processTextNode(node);
		} else if (node.nodeType === Node.ELEMENT_NODE) {
			node.childNodes.forEach(childNode => self.walkNodes(childNode));
		}
	},

	sharePage: function() {
		const urls = {
			x: 'http://twitter.com/share?text=[TITLE]&url=[URL]',
			facebook: 'http://www.facebook.com/sharer.php?u=[URL]&t=[TITLE]',
			pinterest: 'http://pinterest.com/pin/create/button/?url=[URL]&description=[TITLE]',
			linkedin: 'https://www.linkedin.com/shareArticle?mini=true&url=[URL]&title=[TITLE]',
		};

		jQuery( '[data-sikmon="share"]' ).on( 'click', function( event ){
			event.preventDefault();

			jQuery.fancybox.open({
				src: '#share-modal',
				type : 'inline',
				touch: false,
			});
		});

		jQuery( '.share-modal .fancybox-modal__main .button' ).on( 'click', function( event ){
			event.preventDefault();

			let type = jQuery( this ).attr( 'data-type' );
			let url = urls[ type ].replace( '[URL]', encodeURI( window.location.href ) ).replace( '[TITLE]', encodeURI( document.title ) );

			// console.log( url );
			window.open( url, '_blank' );
		});
	},

	smoothSroll: function() {
		jQuery('.blocks .block a[href*="#"]:not([href="#"]), [data-smoothscroll]').on( 'click', function(event) {
			if (jQuery(this).closest( '.js-profileTabs' ).length != 0) {
				return;
			}
			
			// Check if the clicked link's destination is on the same page
			if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
				// Find the target element
				var target = jQuery(this.hash);
				target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
				// If the target exists, perform the smooth scroll
				if (target.length) {
					// Prevent the default action of the link
					event.preventDefault();
					jQuery('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function() {
						// Callback after animation
						// Change focus to the target element (for accessibility reasons)
						var $target = jQuery(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});
	},

	toggleaMap: function() {
		if( document.querySelectorAll( '.js-toggleMap' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '.js-toggleMap' ).forEach(button => {
			
			button.addEventListener( 'click', (event) => {
				event.preventDefault();
				document.querySelector( '.js-mapListing' ).classList.toggle( 'active-map-view' );

				if( ! jQuery( '.js-mapListing' ).hasClass( 'active-map-view' ) ) {
					jQuery( '.map-listing__detail.active' ).addClass( 'd-none' ).removeClass( 'active' );
					jQuery( '.switching-list.d-none' ).removeClass( 'd-none' );
				} else {
					jQuery( '.map-listing__detail' ).removeClass( 'd-none' );
				}

				setTimeout(function(){
					document.querySelectorAll('.tile-switching').forEach(tile => {
						let dataTitle = tile.getAttribute('data-title');
						let dataPoid = tile.getAttribute('data-poid');

						if (dataTitle && dataPoid) {
							document.querySelectorAll(`[title="${dataTitle.trim()}"]`).forEach(element => {
								element.setAttribute('data-map-poid', dataPoid);
							});
						}

						document.querySelectorAll( `img[src$="#poid-${dataPoid}"]` ).forEach( img => {
							img.parentElement.setAttribute('data-map-poid', dataPoid);
						});
					});

					document.querySelectorAll('[data-map-poid]').forEach(el => el.classList.remove('active'));
					document.querySelectorAll('.tile-switching.filtered-active').forEach(tile => {
					  document.querySelectorAll(`[data-map-poid="${tile.dataset.poid}"]`).forEach(el => el.classList.add('active'));
					});

				}, 3500);

	
	
			});
		});

		// ======== PAP PRYČ =========
		/* document.querySelectorAll( '.js-mapListing .tile-switching a' ).forEach(link => {
			
			link.addEventListener( 'click', (event) => {
				event.preventDefault();
				document.querySelector(' .js-mapListing ' ).classList.toggle( 'active-map-detail-view' );
			});
		}); */
		// ======== PAP PRYČ =========
	},

	playVideo: function() {
		if( document.querySelectorAll( '.block-video__wrapper' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '.block-video__wrapper' ).forEach(videoWrapper => {
			if( ! videoWrapper.querySelector( 'video' ) || ! videoWrapper.querySelector( 'video' ) ) {
				return;
			}

			const video = videoWrapper.querySelector( 'video' );

			const button = videoWrapper.querySelector( 'button' ).addEventListener( 'click', (e) => {
				if( videoWrapper.closest( '.block-video' ).classList.contains( 'playing' ) ) {
					video.pause();
				} else {
					video.play();
				}

				videoWrapper.closest( '.block-video' ).classList.toggle( 'playing' );
			});
		});
	},

	inlineYoutube: function () {
		if( document.querySelectorAll( '.youtube-inline-player' ).length == 0 ) {
			return false;
		}

		document.querySelectorAll( '.youtube-inline-player' ).forEach(videoWrapper => {
			videoWrapper.addEventListener( 'click', (event) => {

				var videoId = videoWrapper.getAttribute('data-youtube');
				videoWrapper.classList.add('played');

				videoWrapper.innerHTML = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&mute=0&rel=0&" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="parent-background"></iframe>';
			});
		});
	},

	loadTabs: function() {
		var self = this;

		if( document.querySelectorAll( '.js-basicTabs a' ).length == 0 ) {
			return false;
		}
		
		document.querySelectorAll( '.js-basicTabs a' ).forEach(function( button, item ){
			button.addEventListener( 'click', (e) => {
				e.preventDefault();

				let anchor = e.target.getAttribute( 'href' ).replace( '#', '' );
				self.switchTab( anchor );
			});
		});
	},

		switchTab: function( toTab ) {
			var self = this;

			if( ! document.querySelector( `#${toTab}` ) ) {
				return false;
			}

			document.querySelector( '.js-basicTabs li.active' ).classList.remove( 'active' );
			document.querySelector( '.tabs__content.active' ).classList.remove( 'active' );
			
			document.querySelector( `.js-basicTabs li:has( a[href="#${toTab}"] )` ).classList.add( 'active' );
			document.querySelector( `#${toTab}.tabs__content` ).classList.add( 'active' );
		},



	dateLimited: function() {
		var self = this;
	
		const today 	= new Date();
		const elements 	= document.querySelectorAll( '[data-limitedstart][data-limitedend]' );
		const isEvent 	= document.querySelector( 'body' ).classList.contains( 'single-event' );		
	
		elements.forEach(element => {
			const startDate = self.parseDateTime(element.getAttribute('data-limitedstart'));
			const endDate = self.parseDateTime(element.getAttribute('data-limitedend'));
			const isRowEvent	= element.classList.contains( 'single-row-event' );

			if( isEvent || isRowEvent ) {
				let showRow = self.viewDate( today, element, startDate, endDate );
				
				if( showRow ) {
					element.removeAttribute( 'data-limitedstart' );
					element.removeAttribute( 'data-limitedend' );
				}
				
				return false;
			}

			// basic
			if ( today >= startDate && today <= endDate ) {
				element.removeAttribute( 'data-limitedstart' );
				element.removeAttribute( 'data-limitedend' );
			}			
		});
	},

		viewDate: function( date, element, startDate, endDate ) {
			let finalDateTime = null;

			if (isNaN(startDate) && isNaN(endDate)) {
				return false;
			}
		
			if (!isNaN(startDate) && isNaN(endDate)) {
				finalDateTime = new Date(startDate);
				finalDateTime.setDate(startDate.getDate() + 1);
			}
		
			if (isNaN(startDate) && !isNaN(endDate)) {
				finalDateTime = new Date(endDate);
			}
		
			if (!isNaN(startDate) && !isNaN(endDate)) {
				finalDateTime = new Date(endDate);
			}
		
			if (finalDateTime > date) {
				return true;
			}
		
			return false;
		},

		parseDateTime: function(dateTimeString) {
			if (!dateTimeString) return NaN;
		
			// Parse string with date and time like '06/09/2024 17:43'
			const parts = dateTimeString.split(' ');
			if (parts.length < 2) return NaN;
			const datePart = parts[0].split('/');
			const timePart = parts[1].split(':');
		
			// Convert to a Date object
			const parsedDate = new Date(
				datePart[2], // year
				datePart[1] - 1, // month (0-indexed)
				datePart[0], // day
				timePart[0], // hours
				timePart[1] // minutes
			);
		
			return parsedDate;
		},

		// parseDate: function(dateString) {
		// 	var self = this;

		// 	const parts = dateString.split("/");
		// 	return new Date(parts[2], parts[1] - 1, parts[0]);
		// },
		
};

jQuery(document).ready(function ($) {
	theme.init();
});